import React, { useState } from "react";
import InputChildrenCount from "./components/InputChildreCount";
import BarrioSelector from "../../forms/BarrioSelector";
//import { useUser } from "../../../context/UserContext";
//import PlanCard from "./planes/PlanCard";
import { childcarePlans } from "../../../planesNaiñeras/typePlanes";
import AnimatedSection from "../../../tools/AnimatedSection";


const DAYS_OPTIONS = ["L", "M", "MI", "J", "V", "S", "D"];
const PLAN_OPTIONS = ["Niñera", "Niñera c/t domestica", "Niñera pedagógica", "Empleada domestica"];
const SCHEDULE_OPTIONS = ["mañana", "tarde", "noche"];
const SCHEDULE_HORA = ["Niñera por hora", "Niñera mensual"];
const TIPO_PAGO = ["Blanco", "Negro","Monotributista"];

export default function RequestNannyModal({
  isOpen ,
  onClose = () => {},
  onSubmit = () => {},
}) {


 // const { user } = useUser(); // Accede a los datos del usuario desde el contexto

  // Controla qué vista se muestra: 1 = Formulario, 2 = Sugerencias
  const [step, setStep] = useState(1);

  // Manejo del formulario en el Paso 1
  const [formData, setFormData] = useState({
    plan: "",
    schedule: "",
    days: [],
    childer:[],
    barrioZona:[],
    chats:[],
    contratacion:"",
    typePago:"",
    propuestaEconomica:"",
    rangoDeEdadNiñera:'',
    niñeraIdeal:'',
    metodoTransporte:'',
    tipoPlan:'',
    timeRange:'',
  });

  // Manejo de la niñera seleccionada en el Paso 2
  const [selectedNanny, setSelectedNanny] = useState(null);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  // Manejar la selección del plan
  const handlePlanSelection = (plan) => {
    setFormData((prev) => ({ ...prev, plan }));
  };

  // Manejar la selección del rango de horario
  const handleScheduleSelection = (schedule) => {
    setFormData((prev) => ({ ...prev, schedule }));
  };
  
    // Manejar la selección hijos
    const handleChildren = (childer) => {
      setFormData((prev) => ({ ...prev, childer }));
    };


    // Manejar el rango de horario
  const handleTimeRangeChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({ ...prev, timeRange: value })); 
  };
  
  // Manejar la selección del rango de handleContratacion
  const handleContratacion = (contratacion) => {
    setFormData((prev) => ({ ...prev, contratacion }));
  };

  // Manejar la selección del rango de handleContratacion
  const handleTypePago = (typePago) => {
    setFormData((prev) => ({ ...prev, typePago }));
  };




 const changePropuesta =  (e) => {
  const { name, value } = e.target;
  setFormData((prevData) => ({
    ...prevData,
    [name]: value, // Actualiza el valor correspondiente
  }));
};


/* Coloco funciones para las nuevas actualizaciones */
// Puedes agregar estas funciones o manejar los cambios directamente en los onClick
const handleTipoPlan = (tipo) => {
  setFormData({...formData, tipoPlan: tipo});
};

const handleRangoEdad = (e) => {
  const { value } = e.target;
  setFormData((prev) => ({ ...prev, rangoDeEdadNiñera: value }));
};

const handleNiñeraIdeal = (e) => {
  const { value } = e.target;
  setFormData((prev) => ({ ...prev, niñeraIdeal: value }));
};

const handleMetodoTransporte = (e) => {
  const { value } = e.target;
  setFormData((prev) => ({ ...prev, metodoTransporte: value }));
};

  // Manejar la selección de días
  const handleDayToggle = (day) => {
    setFormData((prev) => {
      const { days } = prev;
      // Si el día ya está seleccionado, lo removemos; si no, lo agregamos
      const updatedDays = days.includes(day)
        ? days.filter((d) => d !== day)
        : [...days, day];
      return { ...prev, days: updatedDays };
    });
  };


  const handleZone=(e)=>{
    /*   console.log(e); */
      
        setFormData({ ...formData, barrioZona: e })
      }



  // Validar datos y pasar a la siguiente pantalla
  const goToSuggestions = () => {
    // Validación simple: todos los campos llenos
    if (!formData.plan || !formData.schedule || !formData.days.length === 0) {
      alert("Por favor, completa todos los campos para continuar.");
      return;
    }
    setStep(2);
  };

  // Validar datos y pasar a la siguiente pantalla      ***** VAlidar los datops de los hijos "canitadad" 
  const goToSuggestions3 = () => {
    // Validación simple: todos los campos llenos
    if (!formData.plan || !formData.schedule || !formData.childer.length === 0) {
      alert("Por favor, completa todos los campos para continuar.");
      return;
    }
    setStep(3);
  };

  // add Nana in formData

  /* const addNana=(nana)=>{
    setSelectedNanny(nana)
  } */

  // Acción final al confirmar la niñera seleccionada
  const handleConfirm = async () => {
    if (!showConfirmationModal) {
      setShowConfirmationModal(true);
      return;
    }

    // Podrías enviar formData + selectedNanny al padre
    const finalData = { ...formData, nannyId: selectedNanny };
    onSubmit(finalData);
    // Opcional: cerramos el modal
    onClose();
    // Reseteamos estados (opcional, según tu flujo)
    setStep(1);
    setFormData({
      plan: "",
      schedule: "",
      days: [],
      childer: [],
      barrioZona: [],
      contratacion: "",
      typePago: "",
      propuestaEconomica: "",
    });
    setSelectedNanny(null);
    setShowConfirmationModal(false);
  };

  const closeConfirmationModal = () => {
    setShowConfirmationModal(false);
  };

  // Permitir volver al formulario
  const handleBack = () => {
    setStep(1);
  };
    // Permitir volver al formulario
 /*    const handleBack2 = () => {
      setStep(2);
    };
 */
  // Si no está abierto, retornamos null para no renderizar nada
  if (!isOpen) return null;
//console.log(user.sub,'user');

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
     
      {/* Confirmation Modal */}
      {showConfirmationModal && (

        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-96">
            <h2 className="text-lg font-bold text-gray-700 mb-4">
              Confirmación
            </h2>
            <p className="text-gray-600 mb-6">
              Por favor, revise con detalle el tipo de servicio que va a Solicitar.
              Este no se puede modificar luego de solicitarlo. ¿Desea continuar?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={closeConfirmationModal}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
              >
                Cancelar
              </button>
              <button
                onClick={handleConfirm}
                className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>

      )}
      
      <div
        /* style={{border:"solid 2px red"}} */ className="bg-white p-6 rounded-lg shadow-lg w-96 h-[100%] relative overflow-scroll"
      >

        {/* Botón para cerrar modal */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>
        <AnimatedSection delay={0.3} >

        {/* Paso 1: Formulario (fade in/out) */}
        <div
          className={`transition-all duration-500 ${
            step === 1 ? "opacity-100 block" : "opacity-0 hidden"
          }`}
        >
          <h3 className="text-lg font-bold text-gray-700 mb-4">
            Solicitar Niñera
          </h3>
          <form className="space-y-4">
            {/* Selección del Plan */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Selecciona un Servicio:
              </label>

              <div
                /*  style={{border:"solid 2px red"}} */ className="flex flex-wrap justify-start gap-4"
              >
                {PLAN_OPTIONS.map((planOption) => (
                  <button
                    key={planOption}
                    type="button"
                    className={`px-4 py-2 border rounded-lg ${
                      formData.plan === planOption
                        ? "bg-blue-500 text-white"
                        : "bg-gray-200 text-gray-700"
                    }`}
                    onClick={() => handlePlanSelection(planOption)}
                  >
                    {planOption.charAt(0).toUpperCase() + planOption.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            {/* Selección del Rango de Horario */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Selecciona el Rango de Horario:
              </label>
              <div className="flex space-x-4">
                {SCHEDULE_OPTIONS.map((scheduleOption) => (
                  <button
                    key={scheduleOption}
                    type="button"
                    className={`px-4 py-2 border rounded-lg ${
                      formData.schedule === scheduleOption
                        ? "bg-blue-500 text-white"
                        : "bg-gray-200 text-gray-700"
                    }`}
                    onClick={() => handleScheduleSelection(scheduleOption)}
                  >
                    {scheduleOption.charAt(0).toUpperCase() +
                      scheduleOption.slice(1)}
                  </button>
                ))}
              </div>
            </div>

     {/* Input for time range */}
         {formData.schedule && (
                <div className="mt-4">
                  <label className="block text-gray-700 font-medium mb-2">
                    Especifica el horario (ej: 8 am a 12 pm)
                  </label>
                  <input
                    type="text"
                    value={formData.timeRange}
                    onChange={handleTimeRangeChange}
                    placeholder="8 am a 12 pm"
                    className="p-2 border rounded-lg w-full"
                  />
                </div>
              )}



            {/* Selección x HOra o Mensual */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Tipo de Contratación:
              </label>
              <div className="flex space-x-4">
                {SCHEDULE_HORA.map((tipoContratacion) => (
                  <button
                    key={tipoContratacion}
                    type="button"
                    className={`px-4 py-2 border rounded-lg ${
                      formData.contratacion === tipoContratacion
                        ? "bg-blue-500 text-white"
                        : "bg-gray-200 text-gray-700"
                    }`}
                    onClick={() => handleContratacion(tipoContratacion)}
                  >
                    {tipoContratacion.charAt(0).toUpperCase() +
                      tipoContratacion.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            

            {/* Selección de los Días de la Semana */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Selecciona los Días de la Semana:
              </label>
              <div className="flex space-x-2 flex-wrap">
                {DAYS_OPTIONS.map((day) => (
                  <button
                    key={day}
                    type="button"
                    className={`px-3 py-2 border rounded-lg ${
                      formData.days.includes(day)
                        ? "bg-blue-500 text-white"
                        : "bg-gray-200 text-gray-700"
                    }`}
                    onClick={() => handleDayToggle(day)}
                  >
                    {day}
                  </button>
                ))}
              </div>
            </div>

            {/* Selección de los Días de la Semana */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                ¿En que zona prefieres que resida la niñera?
              </label>
              <BarrioSelector from='padres' handleZone={handleZone} />
            </div>

            {/* Selección de CONTRATACIÓN */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Selecciona forma de Contrato:
              </label>
              <div className="flex space-x-2 flex-wrap">
                {TIPO_PAGO.map((typePago) => (
                  <button
                    key={typePago}
                    type="button"
                    className={`px-4 py-2 border rounded-lg ${
                      formData.typePago === typePago
                        ? "bg-blue-500 text-white"
                        : "bg-gray-200 text-gray-700"
                    }`}
                    onClick={() => handleTypePago(typePago)}
                  >
                    {typePago.charAt(0).toUpperCase() + typePago.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            {/* Escriba la propuesta económica */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Escriba la propuesta económica:
              </label>
              <div className="flex space-x-2 flex-wrap">
                <input
                  type="text"
                  name="propuestaEconomica"
                  value={formData.propuestaEconomica}
                  placeholder="$00.00"
                  onChange={changePropuesta}
                  className="p-4 bg-gray-100 rounded shadow-md "
                />
              </div>
            </div>


            {/* Rango de edad */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Rango de Edad:
              </label>
              <div className="flex space-x-2 flex-wrap">
                <input
                  type="text"
                  name="rangoDeEdadNiñera"
                  value={formData.rangoDeEdadNiñera}
                  placeholder="24 -30 años"
                  onChange={handleRangoEdad}
                  className="p-4 w-full bg-gray-100 rounded shadow-md "
                />
              </div>
            </div>

         {/* Niñera ideal */}
         <div>
              <label className="block text-gray-700 font-medium mb-2">
                Niñera Ideal:
              </label>
              <div className="flex space-x-2 flex-wrap">
                <input
                  type="text"
                  name="niñeraIdeal"
                  value={formData.niñeraIdeal}
                  placeholder="Describe a tu niñera"
                  onChange={handleNiñeraIdeal}
                  className="p-4 w-full bg-gray-100 rounded shadow-md "
                />
              </div>
            </div>

             {/* Metodo de transporte */}
         <div>
              <label className="block text-gray-700 font-medium mb-2">
                Transporte:
              </label>
              <div className="flex space-x-2 flex-wrap">
                <input
                  type="text"
                  name="metodoTransporte"
                  value={formData.metodoTransporte}
                  placeholder="Tipo de Transporte de la Niñera"
                  onChange={handleMetodoTransporte}
                  className="p-4 w-full bg-gray-100 rounded shadow-md "
                />
              </div>
            </div>

            {/* Selección de Tipo de Plan */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Selecciona el Tipo de Plan:
              </label>
              <div className="flex flex-wrap gap-4">
                {childcarePlans.map((plan) => (
                  <div key={plan.id} className="w-full border rounded-lg p-4 bg-gray-100 shadow-md">
                    {/* Plan Name */}
                    <button
                      type="button"
                      className={`w-full px-4 py-2 border rounded-lg mb-2 ${
                        formData.tipoPlan === plan.name
                          ? "bg-blue-500 text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                      onClick={() => handleTipoPlan(plan.name)}
                    >
                      {plan.name}
                    </button>

                    {/* Plan Details */}
                    <ul className="text-sm text-gray-600 list-disc pl-5 mb-2">
                      {plan.features.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>

                    {/* Plan Price */}
                    <p className="text-sm text-gray-700 font-semibold">
                      Precio: ${plan.price}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Botones de Acción */}
            <div className="flex justify-end mt-4">
            <button
                type="button"
                onClick={goToSuggestions}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Siguiente
              </button>
            
            </div>
          </form>
        </div>

        {/* Paso 2: Formulario (fade in/out) */}
        <div
          className={`transition-all h-90  duration-500 ${
            step === 2 ? "opacity-100 block" : "opacity-0 hidden"
          }`}
        >
          <h3 className="text-lg font-bold text-gray-700 mb-4">
            Sobre los niños a cuidar
          </h3>
          <form className="space-y-4">
            {/* Selección del Plan */}

            <InputChildrenCount handleChildren={handleChildren} />
  
       {/* Botones de Acción */}
            <div className="flex justify-between mt-4">
              <button
                type="button"
                onClick={handleBack}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Volver
              </button>

              <button
                type="button"
                onClick={goToSuggestions3}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Siguiente
              </button>
            </div>
          </form>
        </div>



        {/* Paso 3: Niñeras Sugeridas (fade in/out) */}
        <div
          className={`transition-all duration-500 ${
            step === 3 ? "opacity-100 block" : "opacity-0 hidden"
          }`}
        >

<div className="max-w-lg mx-auto bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200">
      {/* Encabezado */}
      <div className="bg-blue-500 text-white text-center py-4">
        <h2 className="text-2xl font-semibold">Tu Solicitud</h2>
      </div>
          {console.log(formData,'formData new udpate')}
      {/* Contenido */}
      <div className="p-6 space-y-4">
        {/* Info General */}
        <div>
          <h3 className="text-lg font-semibold text-gray-700">📌 Información General</h3>
          <p className="text-gray-600"><strong>Tipo:</strong> {formData.plan}</p>
          <p className="text-gray-600"><strong>Horario:</strong> {formData.schedule}</p>
          <p className="text-gray-600"><strong>Días:</strong> {formData.days.join(", ")}</p>
          <p className="text-gray-600"><strong>Zona:</strong> {formData.barrioZona.join(", ")}</p>
        </div>

        {/* Info del Niño */}
        {formData.childer?.map((child, index) => (
          <div key={index} className="bg-gray-100 p-4 rounded-lg">
            <h3 className="text-lg font-semibold text-gray-700">👶 Niño/a</h3>
            <p className="text-gray-600"><strong>Nombre:</strong> {child.name}</p>
            <p className="text-gray-600"><strong>Edad:</strong> {child.age} años</p>
            <p className="text-gray-600"><strong>Medicación:</strong> {child.takesMedication ? "Sí" : "No"}</p>
            <p className="text-gray-600"><strong>Cuidado Especial:</strong> {child.specialCare}</p>
          </div>
        ))}

        {/* Especificaciones de la niñera */}
        <div  className="bg-gray-100 p-4 rounded-lg">
          
        <h3 className="text-lg font-semibold text-gray-700">Tipo de Niñera</h3>
          <p className="text-gray-600"><strong>Rango de Edad:</strong> {formData.rangoDeEdadNiñera}</p>
          <p className="text-gray-600"><strong>Niñera Ideal:</strong> {formData.niñeraIdeal}</p>
          <p className="text-gray-600"><strong>Transporte:</strong> {formData.metodoTransporte}</p>
          <p className="text-gray-600"><strong>Plan:</strong> {formData.tipoPlan}</p>
        </div>



        {/* Propuesta Económica */}
        <div>
          <h3 className="text-lg font-semibold text-gray-700">💰 Propuesta Económica</h3>
          <p className="text-gray-600"><strong>Tipo de Contratación:</strong> {formData.contratacion}</p>
          <p className="text-gray-600"><strong>Monto:</strong> ${formData.propuestaEconomica}</p>
          <p className="text-gray-600"><strong>Tipo de Pago:</strong> {formData.typePago}</p>
        </div>
      </div>
    </div>
          
          {/* Botones de Acción */}
          <div className="flex justify-end mt-4">
            <button
              type="button"
              onClick={handleBack}
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 mr-2"
            >
              Reiniciar
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
            >
              Confirmar
            </button>
          </div>
        </div>

        </AnimatedSection>

      </div>


    </div>
  );
}
